<template>
    <div id="direct_message" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered mx-auto" role="document">
      <div class="modal-content closefriend-modal">
        <button type="button" class="close text-white" data-dismiss="modal" @click="cancel" style="position: absolute; right: 20px; top: 15px; z-index: 10; opacity: 0.7; text-shadow: none; outline: none;">
          <span aria-hidden="true" style="font-size: 28px;">&times;</span>
        </button>
        <div class="modal-body text-center">
          <h4 class="pt-3 font-size-24">Direct Message <span class="font-success"></span></h4>
          <p class="pt-3 pb-3">Send Message Directly to {{ name }}</p>
                    <div v-if="errorMessage" class="text-danger">{{ errorMessage }}</div>
                    <textarea class="form-control my-2 p-2 rounded" rows="4"
                        style="background-color: #1a1a1a !important; color: #fff !important; border: 1px solid #333 !important;"
                        placeholder="Type your message here..."
                        v-model="text"></textarea>
                    <div class="d-flex justify-content-center mt-4">
                        <button type="button" class="btn font-weight-500 rounded-pill stella-btn gradient-a text-white px-4 py-2"
                            @click="confirm">Send Message
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { SERVICE_DIRECT_MESSAGE } from "@/properties/micro-service";
import { mapGetters } from "vuex";
import { modelHttpMixin } from "@/mixin/model-http-mixin";

export default {
    name: "ModelDirectMessage",
    mixins: [modelHttpMixin],
    data() {
        return {
            text: '',
            name: '',
            errorMessage: '',
            customerSubscription: ''
        }
    },
    computed: {
        ...mapGetters(['getUser'])
    },
    methods: {
        cancel() {
            this.text = '';
        },
        async confirm() {
            if (this.text.trim() === '') {
                this.errorMessage = 'Message cannot be empty.';
                setTimeout(() => {
                    this.errorMessage = '';
                }, 3000);
                return;
            }
            let chatMessage = {
                "message": this.text,
                "senderId": this.getUser.id,
                "receiverId": this.customerSubscription.customerId,
                "contentId": null,
                "status": "S",
                "locked": false,
                "read": false
            };
            let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}`;
            this.postData(url, chatMessage, (message) => {
                this.text = '';
                this.hide();
                this.$store.dispatch('setMessage', 'Direct message sent successfully!');
            })
        },

        show(name, customerSubscription) {
            $('#direct_message').modal();
            if(name != null){
            this.name = name;
            }
            else {
                this.name = customerSubscription.email;
            }
            this.customerSubscription = customerSubscription;
        },
        hide() {
            $('#direct_message').modal('toggle');
        }
    }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 420px;
  margin: 1.5rem auto;
  width: calc(100% - 32px);
}

.modal-content.closefriend-modal {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
</style>

